import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import { Modal, Button, Form, FormGroup, FormControl, ControlLabel } from "react-bootstrap";

export default class AnnouncementBox extends React.Component {
	static defaultProps = {
		delay: 1000,
    position: "bottom-left",
	};

	static propTypes = {
		title: PropTypes.string.isRequired,
		message: PropTypes.string.isRequired,
		ctaText: PropTypes.string,
		ctaUrl: PropTypes.string,
    icon: PropTypes.string,
		delay: PropTypes.number,
    onClick: PropTypes.func,
		onClose: PropTypes.func,
    position: PropTypes.string,
	};

	handleClose() {
		this.setState({open: false});
		if (this.props.onClose) onClose();
	}

	handleCTA() {
		if (this.props.ctaUrl) {
			window.open(this.props.ctaUrl, "_blank", "noopener,noreferrer");
		}
	}

	constructor(props) {
		super(props);

    this.state = {
      open: false,
    };
	}

  componentDidMount() {
			// Show popup after delay
			const timer = setTimeout(() => {
        this.setState({ open: true });
			}, this.props.delay);
  }

	render() {
	
		// Handle controlled/uncontrolled state
		const open = this.state.open;

		if (!open) return null;

    return (<div className={"popup-announcement popup-announcement-" + this.props.position}>
        <div className="popup-announcement-content">
            <div className="popup-announcement-text">
                <h3 className="popup-announcement-title">{this.props.icon ? <span className={"fa fa-" + this.props.icon} style={{"paddingRight": ".2em"}}></span> : null}{" "}{this.props.title}</h3>{" "}
                <div className="popup-announcement-body" dangerouslySetInnerHTML={{__html: this.props.message}}></div>
            </div>
            { this.props.ctaText && (this.props.ctaUrl || this.props.onClick) ? (
                    <button className="popup-announcement-cta" onClick={() => {
                        this.setState({open: false});
                        if (this.props.onClick) this.props.onClick();

                        if (this.props.ctaUrl) {
                          window.open(this.props.ctaUrl, "_blank", "noopener,noreferrer");
                        }
                    }}>
                        {this.props.ctaText}{" "}
                        <span className="right-arrow">
                            <i className="fa fa-arrow-right"></i>
                        </span>
                    </button>
                ) : null }
            <div className="popup-announcement-close" onClick={() => {
                this.setState({open: false});
                if (this.props.onClose) this.props.onClose();
            }}><i className="fa fa-times"></i></div>
        </div>
    </div>);

  }
}
